<template>
  <div data-testid="package-selector" class="package-selector-view min-h-screen bg-white">
    <!-- Header -->
    <section class="bg-white">
      <div class="max-w-6xl mx-auto px-6 lg:px-8 pt-16 pb-12">
        <div class="text-center">
          <p class="text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">{{ $t('packages.selector.subtitle') }}</p>
          <h1 class="text-2xl md:text-3xl font-light text-gray-900">{{ $t('packages.selector.title') }}</h1>
          <p class="text-gray-500 mt-4 max-w-2xl mx-auto">{{ $t('packages.selector.description') }}</p>
        </div>
      </div>
    </section>

    <!-- 3 Blocks -->
    <section class="pb-20">
      <div class="max-w-6xl mx-auto px-6 lg:px-8">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <!-- Cosmetic Block -->
          <router-link
            to="/packages/cosmetic"
            data-testid="package-category-cosmetic"
            class="group relative bg-white border border-gray-200 p-8 hover:shadow-xl hover:border-gray-400 transition-all duration-500 flex flex-col items-center text-center"
          >
            <div class="w-32 h-32 mb-6 rounded-full overflow-hidden bg-pink-50 group-hover:scale-110 transition-transform duration-500 shadow-sm">
              <img
                src="https://achiraya-studio-public.s3.ap-southeast-7.amazonaws.com/assets/mp/cosmetic.webp"
                alt="Cosmetic Services"
                class="w-full h-full object-cover"
              />
            </div>
            <h2 class="text-xl font-medium text-gray-900 mb-3">{{ $t('packages.selector.cosmetic.title') }}</h2>
            <p class="text-sm text-gray-500 mb-6 flex-1">{{ $t('packages.selector.cosmetic.description') }}</p>
            <div class="flex items-center text-sm font-medium text-gray-900 group-hover:translate-x-1 transition-transform">
              {{ $t('packages.selector.view_all') }}
              <ArrowRight class="w-4 h-4 ml-2" />
            </div>
          </router-link>

          <!-- Costume Set Block -->
          <router-link
            to="/packages/costume_set"
            data-testid="package-category-costume-set"
            class="group relative bg-white border-2 border-gray-900 p-8 hover:shadow-2xl transition-all duration-500 flex flex-col items-center text-center"
          >
            <div class="absolute top-0 right-0 bg-gray-900 text-white text-xs px-3 py-1 font-medium">
              {{ $t('packages.selector.popular') }}
            </div>
            <div class="w-32 h-32 mb-6 rounded-full overflow-hidden bg-amber-50 group-hover:scale-110 transition-transform duration-500 shadow-sm">
              <img
                src="https://achiraya-studio-public.s3.ap-southeast-7.amazonaws.com/assets/mp/costume_set.webp"
                alt="Complete Costume Set"
                class="w-full h-full object-cover"
              />
            </div>
            <h2 class="text-xl font-medium text-gray-900 mb-3">{{ $t('packages.selector.costume_set.title') }}</h2>
            <p class="text-sm text-gray-500 mb-6 flex-1">{{ $t('packages.selector.costume_set.description') }}</p>
            <div class="flex items-center text-sm font-medium text-gray-900 group-hover:translate-x-1 transition-transform">
              {{ $t('packages.selector.view_all') }}
              <ArrowRight class="w-4 h-4 ml-2" />
            </div>
          </router-link>

          <!-- Photography Block -->
          <router-link
            to="/packages/photography"
            data-testid="package-category-photography"
            class="group relative bg-white border border-gray-200 p-8 hover:shadow-xl hover:border-gray-400 transition-all duration-500 flex flex-col items-center text-center"
          >
            <div class="w-32 h-32 mb-6 rounded-full overflow-hidden bg-blue-50 group-hover:scale-110 transition-transform duration-500 shadow-sm">
              <img
                src="https://achiraya-studio-public.s3.ap-southeast-7.amazonaws.com/assets/mp/photography.webp"
                alt="Photography Services"
                class="w-full h-full object-cover"
              />
            </div>
            <h2 class="text-xl font-medium text-gray-900 mb-3">{{ $t('packages.selector.photography.title') }}</h2>
            <p class="text-sm text-gray-500 mb-6 flex-1">{{ $t('packages.selector.photography.description') }}</p>
            <div class="flex items-center text-sm font-medium text-gray-900 group-hover:translate-x-1 transition-transform">
              {{ $t('packages.selector.view_all') }}
              <ArrowRight class="w-4 h-4 ml-2" />
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <!-- Info Section -->
    <section class="py-16 bg-stone-50">
      <div class="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 class="text-lg font-light text-gray-900 mb-4">{{ $t('packages.selector.help_title') }}</h2>
        <p class="text-gray-500 text-sm">{{ $t('packages.selector.help_description') }}</p>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ArrowRight } from 'lucide-vue-next'
</script>
